export const CalendarViewNewItem = {
  appointment: 'appointment',
  task: 'task',
}

export const CALENDAR_VIEW_NEW_MENU_OPTIONS = [
  {
    label: 'Calendar.NewAppointmentItemKey',
    value: CalendarViewNewItem.appointment,
  },
  { label: 'Calendar.TaskSingularKey', value: CalendarViewNewItem.task },
]

export const QA_NAME_CALENDAR_NEW_MENU = 'calendarNewMenu'
